export default __webpack_public_path__ + "static/media/zayed-project-2.e7cfb1db.jpg";